import { render, staticRenderFns } from "./PackagesInUnit.vue?vue&type=template&id=2df3666b"
import script from "./PackagesInUnit.vue?vue&type=script&lang=js"
export * from "./PackagesInUnit.vue?vue&type=script&lang=js"
import style0 from "./PackagesInUnit.vue?vue&type=style&index=0&id=2df3666b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports